import {Icon} from '@/app/components/Icon';
import {useState} from 'react';
import {Button} from '@/components/app/button';
import {Notice} from '@/components/app/feedback';
import {cn} from '@/lib/utils';
import {useDevice} from '../../../app/hooks/useDevice';
import {useDemo} from '../hooks/useDemo';
export interface DemoMessageProps {
  className?: string;
}
export const DemoMessage = ({className}: DemoMessageProps) => {
  const {isDemo, showLimitReachedDialog} = useDemo();
  const {isMobile, isLandscape} = useDevice();
  const [dismissed, setDismissed] = useState(false);
  if (!isDemo || dismissed) {
    return null;
  }
  return (
    <Notice
      className={cn(className, 'sticky bottom-0 z-2 py-2 rounded-none')}
      content={
        <>
          <div className={'flex flex-col gap-1 text-center text-sm md:flex-row md:gap-2 md:text-base'}>
            THIS IS A DEMO PAGE WITH LIMITED FEATURES.
            <Button
              className={'p-0'}
              onClick={() =>
                showLimitReachedDialog({
                  message: 'Create an account now and discover full features.',
                  title: 'Discover full features!',
                })
              }
              variant="link"
              type="button"
            >
              Click here to sign-up and discover full features!
            </Button>
          </div>
          {isMobile && isLandscape && (
            <Button
              className={cn('text-muted-foreground absolute top-1/2 right-0 -translate-y-1/2 mr-2', 'rounded-full')}
              onClick={() => setDismissed(true)}
              size="sm"
              variant="ghost"
              type="button"
              startIcon={<Icon icon={'times'} />}
              aria-label={'Close'}
            />
          )}
        </>
      }
      tone={'error'}
    />
  );
};
